export interface ISidePanelRef {
  closed: Promise<any>;
  dismissed: Promise<any>;
}
